import { Paragraph } from '@eggplant/pattern-library'

const EmptyStateWithErrorDescription = () =>
  <Paragraph>
    Try updating your search criteria.
    <br />
    There is something wrong please search again.
  </Paragraph>

export default EmptyStateWithErrorDescription
